export const CONVERSATION_MESSAGE_MODEL = "conversation-message";

const conversationMessageModel = {
  attachments: [],
  sentDate: "",
  body: "",
  conversation: {
    jsonApi: "hasOne",
    type: "conversations"
  },
  sender: {
    jsonApi: "hasOne",
    type: "users"
  }
};

export default conversationMessageModel;
